// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2faii","label":"LabeledBox_label__1xXew"};